'use client';

import './index.css';
import './links.css';
import './cta.css';

import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { Button } from '@/components/button';
import { Link } from '@/components/link';
import { MaxWidth } from '@/components/max-width';

import { CONFIG } from '@/config';

export const HeaderClient = ({
  blok,
  navbarCtaOverwrite,
  overrideHeader = false,
}) => {
  const pathname = usePathname();
  const isHomePage = pathname === '/';

  const navbarItems = blok?.content?.navbarItems || [];

  const navbarCta = useMemo(() => {
    const array = (blok?.content?.navbarCta || []).slice();

    for (const [index, item] of navbarCtaOverwrite?.entries?.() || []) {
      array.splice(index, 1, item);
    }

    return array;
  }, [blok?.content?.navbarCta, navbarCtaOverwrite]);

  return (
    <header
      className={classNames('header', {
        'header--other': !isHomePage,
        // 'header--override-header': overrideHeader,
      })}
    >
      <MaxWidth>
        <Link href="/" className="header__logo">
          <img
            src="/static/unlockm-primary.svg"
            width="182"
            height="44"
            alt={CONFIG.title}
          />
        </Link>

        <nav className="header__links">
          {navbarItems.map((item) => {
            const hasSubItems = item.subItems?.length > 0;
            const titleContent = (
              <>
                {item.title}

                {hasSubItems ? (
                  <img
                    className="header__link__sub-icon"
                    src="/static/icons/chevron-down.svg"
                    width="20"
                    height="20"
                    alt=""
                  />
                ) : null}
              </>
            );

            return (
              <div
                key={item._uid}
                className={classNames('header__link', {
                  'header__link--has-sub-links': hasSubItems,
                })}
              >
                {item.link && (item.link.url || item.link.id) ? (
                  <Link link={item.link}>{titleContent}</Link>
                ) : (
                  <span className="header__link__title">{titleContent}</span>
                )}

                {hasSubItems ? (
                  <div className="header__link__sub-links">
                    {item.subItems.map((subItem) => {
                      return (
                        <Link
                          key={subItem._uid}
                          link={subItem.link}
                          className="header__link__sub-link"
                        >
                          {subItem.title}
                        </Link>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            );
          })}
        </nav>

        <div className="header__cta">
          {navbarCta.map((item) => {
            return (
              <Button
                key={item._uid}
                link={item.link}
                theme={item.theme || 'primary'}
              >
                {item.title}
              </Button>
            );
          })}
        </div>
      </MaxWidth>
    </header>
  );
};
